<template>
    <b-badge v-if="statusInfo" :variant="statusInfo.variant"> {{ statusInfo.text }} Puan </b-badge>
    <span v-else>-</span>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    components: {
        BBadge,
    },
    props: {
        row: Object,
        field: [Number, String],
    },
    computed: {
        statusInfo() {
            const totalPoints = Number(this.field || 0);
            const remainingPoints = Math.max(0, 100 - totalPoints);

            let variant = "light-dark";

            if (totalPoints >= 75) {
                variant = "light-danger";
            } else if (totalPoints >= 50) {
                variant = "light-warning";
            } else if (totalPoints > 20) {
                variant = "light-info";
            }

            return {
                text: remainingPoints,
                variant: variant,
            };
        },
    },
};
</script>
